import { ContactPersonRole } from '../../../providers/ActivationObjectProvider/types'
import { GenericDropdownItem } from '../../../../types'
import { ReactionType, WizzardStep4Form } from '../types'

export const DefaultValue: WizzardStep4Form = {
    complyWithGuidelines: true,
    comunicationPassword: null,
    appMyJablotronEmail: '',
    personContacts: [
        {
            email: '',
            phone: '',
            fullName: '',
            role: 'Contact',
            creatAccountToZZ: false,
            order: 0,
        },
    ],
}

export const ContactPersonRoleDesc: Record<ContactPersonRole, string> = {
    Admin: 'Administrátor',
    Contact: 'Uživatel',
}
export const ContactPersonRoleList: GenericDropdownItem<ContactPersonRole>[] = Object.keys(ContactPersonRoleDesc).map((key) => {
    return {
        value: key as ContactPersonRole,
        label: (ContactPersonRoleDesc as any)[key],
    }
})

export const ReactionTypeDesc: Record<ReactionType, string> = {
    Alert: 'Po přijetí zprávy POPLACH čeká Tísňová linka 1 minutu na zrušení poplachu platným kódem uživatele. Pokud ke zrušení poplachu nedojde, volá Tísňová linka kontaktní osoby. V případě, že se nepodaří kontaktním osobám dovolat, vysílá Tísňová linka zásahovou jednotku na kontrolu objektu. Zákazník má možnost výjezd odvolat voláním na Tísňovou linku 244 020 220.',
    Panic: 'Po přijetí zprávy PANIKA Tísňová linka neprodleně vysílá zásahovou jednotku na kontrolu objektu a nevolá kontaktní osoby. Zákazník má možnost výjezd odvolat voláním na Tísňovou linku 244 020 220.',
    Failure: 'SMS notifikace na Kontaktní osobu č. 1 pouze v čase 8:00 - 22:00',
    ConnectionLost: 'SMS notifikace na Kontaktní osobu č. 1 v čase 0:00 - 23:59',
}
